export const FXBO = "FXBO";
export const BSS = "BSS";
export const JP = "jp";
export const VN = "vn";
export const TH = "th";
export const SC = "sc";
export const TC = "tc";
